import { Badge, Card, EmptyState, PageHeader, Spinner, cn } from '@dnx/ui';
import { useQuery } from '@tanstack/react-query';
import { Link } from '@tanstack/react-router';
import { Scissors } from 'lucide-react';
import { SURGERY_STATUS, surgeriesQuery } from './surgery-tab.js';

const dt = (iso: string) => new Date(iso).toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo', weekday: 'short', day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' });

/** Cirurgias: casos em preparação, agendados e realizados, com o progresso do checklist. */
export function SurgeriesPage() {
  const { data, isLoading } = useQuery(surgeriesQuery());
  return (
    <div className="mx-auto max-w-6xl">
      <PageHeader title="Cirurgias" description="Do orçamento aceito à cirurgia: checklist pré-operatório, agenda e registro do procedimento." />
      {isLoading ? <Spinner className="mt-10 size-5 text-fg-subtle" label="Carregando" /> : data?.length ? (
        <Card className="mt-7 divide-y divide-border overflow-hidden">
          {data.map((s) => (
            <Link key={s.id} to="/pacientes/$id" params={{ id: s.patientId }} search={{ aba: 'cirurgia' }}
              className="grid gap-2 px-5 py-3.5 transition-colors hover:bg-surface-muted sm:grid-cols-[minmax(0,1fr)_220px_170px_130px] sm:items-center">
              <span className="min-w-0"><span className="block truncate font-medium text-fg">{s.patientName}</span><span className="font-mono text-[12.5px] text-fg-muted">{s.quoteCode}</span></span>
              <span className="text-[13px] text-fg-muted">{s.appointment ? dt(s.appointment.startsAt) : 'sem data'}</span>
              <span className="flex items-center gap-2 text-[13px] text-fg-muted">
                <span className="h-1.5 w-20 overflow-hidden rounded-full bg-surface-muted"><span className={cn('block h-full rounded-full', s.ready ? 'bg-success' : 'bg-warning')} style={{ width: `${(s.checklistDone / s.checklistTotal) * 100}%` }} /></span>
                {s.checklistDone}/{s.checklistTotal}
              </span>
              <span><Badge tone={SURGERY_STATUS[s.status][1]}>{SURGERY_STATUS[s.status][0]}</Badge></span>
            </Link>
          ))}
        </Card>
      ) : (
        <EmptyState className="mt-8" icon={<Scissors className="size-6" />} title="Nenhuma cirurgia ainda">
          <p>Quando um orçamento é aceito, abra o caso cirúrgico na ficha do paciente (aba Cirurgia).</p>
        </EmptyState>
      )}
    </div>
  );
}
